import { Switch, Route } from "react-router-dom";
import { TierList } from "./pages/Default/TierList";
import { AppRoutes, RouterPaths } from "@ugg/shared/routes/app-routes";
import { CombatTierListContainer } from "./pages/Combat/CombatTierListContainer";
import { ObjectivesTierListContainer } from "./pages/Objectives/ObjectivesTierListContainer";
import { DuoTierListContainer } from "./pages/Duo/DuoTierListContainer";
import { ArenaTierListContainer } from "@ugg/shared/components/TierList/pages/Arena/ArenaTierListContainer";
import { ArenaDuoTierListContainer } from "@ugg/shared/components/TierList/pages/Arena/ArenaDuoTierListContainer";
import {
  AramMayhemChampionTierListContainer,
  AramMayhemAugmentTierListByRarityContainer,
} from "@ugg/shared/components/TierList/pages/AramMayhem/AramMayhemTierListContainer";
import { ClassicChampionTierListContainer } from "@ugg/shared/components/TierList/pages/Classic/ClassicTierListContainer";

// ─────────────────────────────────────────────────────────────────────
// The single tier-list route table, shared by the website and the
// desktop app.
//
// There used to be a second copy in packages/ugg/src that the website
// rendered while the app rendered this one. They drifted: the web copy
// picked up the Classic and ARAM Mayhem routes and this one never did,
// so the app fell through to the default <TierList /> on those URLs and
// rendered an empty table. (It *reached* them because
// RouterPaths.TIER_LIST includes the SPECIAL_GAME_MODE_TIER_LIST
// catch-all "/lol/:gameMode-tier-list", which matches all three.)
//
// The only real difference between the two shells is the patch-notes
// CTA: it's a WP-GraphQL component that lives in the website's src tree
// and can't be imported from here. So it's a prop, and each shell
// injects (or omits) its own.
// ─────────────────────────────────────────────────────────────────────

interface TierListRoutesProps {
  inNewWindow?: boolean;
  patchNotesCTA?: React.ReactNode;
}

export const TierListRoutes = ({ inNewWindow, patchNotesCTA }: TierListRoutesProps) => {
  return (
    <Switch>
      <Route path={AppRoutes.ARENA_TIER_LIST} render={() => <ArenaTierListContainer patchNotesCTA={patchNotesCTA} />} />
      <Route path={AppRoutes.ARENA_DUO_TIER_LIST} render={() => <ArenaDuoTierListContainer patchNotesCTA={patchNotesCTA} />} />
      <Route path={AppRoutes.DUO_TIER_LIST} render={() => <DuoTierListContainer patchNotesCTA={patchNotesCTA} />} />
      <Route path={AppRoutes.COMBAT_TIER_LIST} render={() => <CombatTierListContainer patchNotesCTA={patchNotesCTA} />} />
      <Route path={AppRoutes.OBJECTIVES_TIER_LIST} render={() => <ObjectivesTierListContainer patchNotesCTA={patchNotesCTA} />} />
      <Route
        path={AppRoutes.CLASSIC_TIER_LIST}
        render={() => <ClassicChampionTierListContainer patchNotesCTA={patchNotesCTA} />}
      />
      <Route
        path={AppRoutes.ARAM_MAYHEM_TIER_LIST}
        render={() => <AramMayhemChampionTierListContainer patchNotesCTA={patchNotesCTA} />}
      />
      <Route
        path={AppRoutes.ARAM_MAYHEM_AUGMENT_TIER_LIST}
        render={() => <AramMayhemAugmentTierListByRarityContainer patchNotesCTA={patchNotesCTA} />}
      />
      {/* Must stay last — RouterPaths.TIER_LIST carries the
          "/lol/:gameMode-tier-list" catch-all, which matches every
          specific route above. */}
      <Route path={RouterPaths.TIER_LIST} render={() => <TierList inNewWindow={inNewWindow} patchNotesCTA={patchNotesCTA} />} />
    </Switch>
  );
};
